module.exports = __webpack_public_path__ + "static/media/exampleLogo.58956039.svg";